import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from "react";
import PropTypes from "prop-types";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import classnames from "classnames";
import styles from "./expandable.css";

function Expandable(_ref) {
  var chevronClass = _ref.chevronClass,
      children = _ref.children,
      className = _ref.className,
      onClick = _ref.onClick,
      renderLabel = _ref.renderLabel;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  function toggleOpen() {
    setOpen(!open); // For owning components to fire analytics etc.

    if (onClick) {
      onClick(open);
    }
  }

  return React.createElement("div", {
    className: classnames(className, "".concat(open ? styles.open : styles.closed))
  }, React.createElement("div", {
    className: styles.button,
    onClick: toggleOpen
  }, renderLabel(open), React.createElement(SVGIcon, {
    className: chevronClass,
    name: "round-chevron",
    rotate: open ? -90 : 90
  })), React.createElement("div", {
    className: styles.content
  }, children));
}

export default Expandable;
Expandable.propTypes = {
  chevronClass: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  renderLabel: PropTypes.func.isRequired
};